// Library
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { teacherSchool } from '..';

export const teacherSlice = createSlice({
  name: 'teacher',
  initialState: {
    teacherSchool: teacherSchool
  },
  reducers: {
    setTeacherSchool: (state, action) => {
      state.teacherSchool = action.payload;
    },
  }
});

// Action creators are generated for each case reducer function
export const { setTeacherSchool } = teacherSlice.actions;
export default teacherSlice.reducer;